import Global from "../Global";
import { ResourceTypeEnum } from "../SuperEnum";
import Tools from "../Tools";
import ad_resource_type from "../vo/dbvo/ad_resource_type";
import ad_resources from "../vo/dbvo/ad_resources";
import ad_resources_group from "../vo/dbvo/ad_resources_group";

export type InputGetResourceInfo = {
    uniqueArr: InputUniqueInfo[];
}
export type InputUniqueInfo = {
    unique_id: string;
    resource_index: number;
};

export type InputAddResource = {
    ResourceName: string;
    ResourceTypeID: number;
    Files?: File[],
    ResourceLinks: string[];
    MediaType?: string;
};

export type InputAddResourceType = {
    ResourceType: ResourceTypeEnum,
    ResourceName: string;
    ResourceDescribe?: string;
    ResourceTopId: number
};

/**
 * 添加资源输入类型
 */
export type InputUpdateResourceType = {
    ResourceID: number;
    ResourceName: string;
    ResourceDescribe?: string;
    ResourceType: ResourceTypeEnum;
    /**
     * 上层资源ID
     */
    ResourceTopId?: number;
};

/**
 * 资源相关API
 */
export default class ResourcesApi {
    /**
     * 获取资源数据列表
     */
    public GetResourceInfoListAsync(input: InputGetResourceInfo) {
        return Tools.FetchAsync<ad_resources[]>("Resources/GetResourceInfoList", input, "POST");
    }

    /**
     * 获取资源媒体类型
     */
    public GetResourceMediaTypeListAsync() {
        return Tools.FetchAsync<ad_resource_type[]>("Resources/GetResourceMediaTypeList", {}, "GET");
    }

    /**
     * 添加资源
     * @param input 
     */
    public AddResourceAsync(input: InputAddResource) {
        return Tools.FetchAsync<ad_resources[]>("Resources/AddResource", input, "POST", "multipart/form-data");
    }

    /**
     * 添加资源类型
     * @param input 
     */
    public AddResourceTypeAsync(input: InputAddResourceType) {
        return Tools.FetchAsync("Resources/AddResourceType", input, "POST");
    }

    /**
     * 更新资源类型
     * @param input 
     */
    public UpdateResourceTypeAsync(input: InputUpdateResourceType) {
        return Tools.FetchAsync("Resources/UpdateResourceType", input, "PATCH");
    }

    /**
     * 获取资源列表
     * @param resourceType 资源类型
     * @param subResourceTypeId 子资源类型ID(可为空)
     * @param page 当前页
     * @param pageSize 每页个数
     */
    public GetResourceListAsync(resourceType: ResourceTypeEnum, subResourceTypeId?: number, page: number = 1, pageSize: number = 20) {
        return Tools.FetchAsync<{
            allcount: number,
            pagecount: number,
            data: ad_resources[]
        }>("Resources/GetResourceList", {
            resourceType,
            subResourceTypeId,
            page,
            pageSize
        }, "GET");
    }

    /**
     * 获取资源组列表
     * @param resourceTypeId 资源类型数据ID
     * @param page 
     * @param pageSize 
     */
    public GetResourceGroupListAsync(resourceTypeId: number, page: number, pageSize: number) {
        return Tools.FetchAsync<{
            allcount: number,
            pagecount: number,
            data: ad_resources_group[]
        }>("Resources/GetResourceGroupList", {
            resourceTypeId,
            page,
            pageSize
        }, "GET");
    }

    /**
     * 获取资源分类类型列表
     * @returns 
     */
    public GetResourceTypeListAsync(resource_type?: ResourceTypeEnum, resource_top_id: number = 0) {
        return Tools.FetchAsync<ad_resource_type[]>("Resources/GetResourceTypeList", {
            resource_top_id,
            resource_type
        }, "GET");
    }
}